import React, { Component } from 'react';
import config from 'react-global-configuration';
import $ from 'jquery';
import { isApiResponse } from '../helpers/utils.js';
import TicketDetailTable from './TicketDetailTable.jsx';
import './TicketReport.css';

class ServicePerMerchantTab extends Component {
  constructor(props) {
    super(props);
    this._dt = null;
    this.state = {
      showDetails: false,
      selectedTeam: null,
      selectedColumnType: null
    };
  }

  componentDidMount() {
    if (this.props.shouldLoadData) {
      this.get_filtered_service_performance_merchant();
      this.props.onDataLoaded();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.shouldLoadData && !prevProps.shouldLoadData) {
      this.get_filtered_service_performance_merchant();
    } else if (
      prevProps.merchantID !== this.props.merchantID ||
      prevProps.chainID !== this.props.chainID ||
      prevProps.storeID !== this.props.storeID ||
      prevProps.yestSend !== this.props.yestSend ||
      prevProps.todSend !== this.props.todSend ||
      prevProps.issue_type !== this.props.issue_type ||
      prevProps.cf_issue_sub_category !== this.props.cf_issue_sub_category ||
      prevProps.city !== this.props.city ||
      prevProps.channel !== this.props.channel ||
      prevProps.product !== this.props.product ||
      prevProps.team !== this.props.team ||
      prevProps.rating !== this.props.rating
    ) {
      this.get_filtered_service_performance_merchant();
    }
  }

  componentWillUnmount() {
    if ($.fn.DataTable.isDataTable('#merchantAgingTable')) {
      $('#merchantAgingTable').DataTable().clear().destroy();
    }
  }

  get_filtered_service_performance_merchant() {
    var that = this;
    if (this.props.shouldLoadData) {
      const postData = {
        start_date: this.props.yestSend,
        end_date: this.props.todSend,
        merchant: this.props.merchantID || [],
        chain: this.props.chainID || [],
        store: this.props.storeID || [],
        issue_category: this.props.cf_issue_sub_category || [],
        city: this.props.city || [],
        channel: this.props.channel || [],
        product: this.props.product || [],
        team: this.props.team || [],
        rating: this.props.rating || [],
        group_by: 'merchant',
        report_code: 'service_performance_merchant_wise',
        download: 0
      };

      isApiResponse(false);

      if ($.fn.DataTable.isDataTable('#merchantAgingTable')) {
        $('#merchantAgingTable').DataTable().clear().destroy();
      }

      var merchantAgingTable = $('#merchantAgingTable').DataTable({
        order: [],
        processing: true,
        serverSide: true,
        bDestroy: true,
        paging: true,
        pageLength: 5,
        bInfo: false,
        responsive: false,
        scrollX: true,
        lengthMenu: [[5, 25, 50, 100, 500], [5, 25, 50, 100, 500]],
        fixedColumns: { leftColumns: 1 },
        ajax: {
          url: config.get('API_URL') + '/ServiceReport/service_performance',
          type: 'POST',
          data: postData,
          dataSrc: function (json) {
            isApiResponse(true);
            that.setState({ isChange: false });
            return json.data;
          },
          beforeSend: function (request) {
            request.setRequestHeader('Authorization', localStorage.usertoken);
          },
          error: function (data) {
            isApiResponse(true);
            alert('Failed to load data. Please try again');
            console.log('error', data);
          },
          complete: function (data) {
            isApiResponse(true);
          }
        },
        columns: [
          { data: 'Merchant Name', width: '180px' },
          { data: 'Opening Balance', width: '100px' },
          { data: 'Tickets Added', width: '100px' },
          { data: 'Within TAT - Tickets Resolved', width: '100px', className: 'text-center' },
          { data: 'Within TAT - Tickets QC Closed', width: '120px', className: 'text-center' },
          { data: 'Within TAT - Tickets Open', width: '100px', className: 'text-center' },
          { data: 'Outside TAT - Tickets Resolved', width: '100px', className: 'text-center' },
          { data: 'Outside TAT - Tickets QC Closed', width: '120px', className: 'text-center' },
          { data: 'Outside TAT - Tickets Open', width: '100px', className: 'text-center' },
          { data: 'Closing Balance (Resolved but Not QC Closed)', width: '150px', className: 'text-center' },
          { data: 'Closing Balance Open', width: '120px', className: 'text-center' },
          { data: '% Tickets Resolved Within TAT', width: '100px', className: 'text-center' },
          { data: '% Tickets QC Closed Within TAT', width: '120px', className: 'text-center' },
          { data: 'Reopened ticket by customer or repeated from same subscription', width: '180px', className: 'text-center' },
          { data: '% of Repeat Tickets', width: '100px', className: 'text-center' },
          { data: 'Average Rating', width: '100px', className: 'text-center' }
        ],
        columnDefs: [
          {
            targets: 0,
            render: function (data) {
              const val = data == null ? '' : String(data);
              return `<div class='text-wrap width-150'>${val}</div>`;
            }
          },
          {
            targets: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 13],
            createdCell: function (td, cellData, rowData, row, col) {
              if (cellData > 0) {
                $(td).css({ cursor: 'pointer' });
                $(td).on('click', function () {
                  that.handleCellClick(rowData, col);
                });
              }
            }
          },
          {
            targets: [11, 12, 14],
            render: function (data) {
              return data == null ? '0%' : data + '%';
            }
          },
          {
            targets: [15],
            render: function (data) {
              return data == null ? '-' : data;
            },
            createdCell: function (td, cellData, rowData, row, col) {
              if (cellData != null) {
                $(td).css({ cursor: 'pointer' });
                $(td).on('click', function () {
                  that.handleCellClick(rowData, col);
                });
              }
            }
          }
        ]
      });

      if (that.props.object_type === 'Innoviti') {
        merchantAgingTable.columns([4, 7, 9, 12, 15]).visible(true);
      } else {
        merchantAgingTable.columns([4, 7, 9, 12, 15]).visible(false);
      }
    }
  }

  handleCellClick(rowData, colIndex) {
    const merchantName = rowData['Merchant Name'];
    const columnTypeMap = {
      1: 'opening_balance',
      2: 'tickets_added',
      3: 'within_tat_resolved',
      4: 'within_tat_qc_closed',
      5: 'within_tat_open',
      6: 'outside_tat_resolved',
      7: 'outside_tat_qc_closed',
      8: 'outside_tat_open',
      9: 'closing_balance_resolved',
      10: 'closing_balance_open',
      13: 'repeat_tickets',
      15: 'has_rating'
    };
    const columnType = columnTypeMap[colIndex];
    if (columnType) {
      this.setState({
        showDetails: true,
        selectedTeam: merchantName,
        selectedColumnType: columnType
      });
    }
  }

  closeDetails() {
    this.setState({
      showDetails: false,
      selectedTeam: null,
      selectedColumnType: null
    });
  }

  render() {
    const { showDetails, selectedTeam, selectedColumnType } = this.state;
    return (
      <div className="merchant-tab-content service-report">
        <div className="content-tdetails-table table-full-width marginTop0">
          <table id="merchantAgingTable" className="table table-striped table-hover">
            <thead>
              <tr>
                <th rowSpan="2" className="merchant-header-default">Merchant Name</th>
                <th rowSpan="2" className="merchant-header-default">Opening Balance</th>
                <th rowSpan="2" className="merchant-header-default">Tickets Added</th>
                <th colSpan="3" className="merchant-header-default">Within TAT</th>
                <th colSpan="3" className="merchant-header-default">Outside TAT</th>
                <th rowSpan="2" className="merchant-header-default">Closing Balance Resolved but Not QC Closed</th>
                <th rowSpan="2" className="merchant-header-default">Closing Balance Open</th>
                <th rowSpan="2" className="merchant-header-default">% Tickets Resolved Within TAT</th>
                <th rowSpan="2" className="merchant-header-default">% Tickets QC Closed Within TAT</th>
                <th rowSpan="2" className="merchant-header-default">
                  Count of tickets re-opened by customer or repeated from same subscription
                </th>
                <th rowSpan="2" className="merchant-header-default">% of Repeat Tickets</th>
                <th rowSpan="2" className="merchant-header-default">Average Rating</th>
              </tr>
              <tr>
                <th className="merchant-header-default">No. Of Tickets Resolved</th>
                <th className="merchant-header-default">No. Of Tickets QC Closed</th>
                <th className="merchant-header-default">No. Of Tickets Open</th>
                <th className="merchant-header-default">No. Of Tickets Resolved</th>
                <th className="merchant-header-default">No. Of Tickets QC Closed</th>
                <th className="merchant-header-default">No. Of Tickets Open</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>

        {showDetails && (
          <TicketDetailTable
            key={`${selectedTeam}-${selectedColumnType}`}
            tableId="servicePerMerchantDetailsTable"
            apiUrl="/ServiceReport/service_performance_details"
            postData={{
              start_date: this.props.yestSend,
              end_date: this.props.todSend,
              download: 0,
              group_by: 'merchant',
              group_value: selectedTeam,
              column_type: selectedColumnType,
              merchant: this.props.merchantID || [],
              chain: this.props.chainID || [],
              store: this.props.storeID || [],
              issue_category: this.props.cf_issue_sub_category || [],
              city: this.props.city || [],
              channel: this.props.channel || [],
              product: this.props.product || [],
              team: this.props.team || [],
              rating: this.props.rating || []
            }}
            title={`Ticket Details - ${selectedTeam}`}
            columnType={selectedColumnType}
            objectType={this.props.object_type}
            onClose={() => this.closeDetails()}
            downloadConfig={{
              fn: 'service_performance_merchant_wise_details.csv.gz',
              url: '/service_reports/service_performance_merchant_details',
              filters: {
                start_date: this.props.yestSend,
                end_date: this.props.todSend,
                download: 1,
                report_code: 'service_performance_merchant_wise_details',
                group_by: 'merchant',
                group_value: selectedTeam,
                column_type: selectedColumnType,
                merchant: this.props.merchantID,
                chain: this.props.chainID || [],
                store: this.props.storeID,
                issue_category: this.props.cf_issue_sub_category,
                city: this.props.city,
                channel: this.props.channel,
                product: this.props.product,
                team: this.props.team,
                rating: this.props.rating
              },
              timeout: 180
            }}
          />
        )}
      </div>
    );
  }
}

export default ServicePerMerchantTab;
